import getConstantPrefixer from '../utils/actions';
import { fetchJSONWithErrorAlert } from '../utils/http';
const prefix = getConstantPrefixer('SHIPPING');


export const SET_SHIPPING_USER_WHITELIST = prefix('SET_USER_WHITELIST');


export const fetchWhitelist = (dispatchFromFC,cb) => async (dispatch, getState) => {
    try {
      const data = await  fetchJSONWithErrorAlert(`/shipping/shipping_profile_white_list`,{},dispatchFromFC); 
      const {shippingProfileWhiteList}=data
      dispatch({
        type: SET_SHIPPING_USER_WHITELIST,
        payload: {shippingProfileWhiteList}
      });
      cb()
    } catch (error) {
      console.error('Failed to fetch whitelist:', error);
      cb()

    }
  };



  
  export const SET_DOMESTIC_INTERNATIONAL_SHIPPING_SERVICES = prefix('SET_DOMESTIC_INTERNATIONAL_SHIPPING_SERVICES');

export const fetchDomesticInternationalShippingServices = (dispatchFromFC) => async (dispatch, getState) => {
    try {
      const data = await  fetchJSONWithErrorAlert(`/shipping/shipping_services`,{},dispatchFromFC); 
      const {domestic_services:domesticShippingServices,international_services:internationalServices }=data
      dispatch({
        type: SET_DOMESTIC_INTERNATIONAL_SHIPPING_SERVICES,
        payload: {domesticShippingServices,internationalServices}
      });
    } catch (error) {
      console.error('Failed to fetch shipping_services:', error);
    }
  };


export const SET_SHIPPING_AUTOCONFIG = prefix('SET_SHIPPING_AUTOCONFIG');
export const SET_SHIPPING_SETTINGS_LOADING = prefix('SET_SHIPPING_SETTINGS_LOADING');


  export const fetchShippingAutoConfig = (dispatchFromFC) => async (dispatch) => {
  
    try {
      dispatch({ type: SET_SHIPPING_SETTINGS_LOADING, payload: {shippingSettingsLoading:true} });
      const data = await fetchJSONWithErrorAlert('/shipping/config/get',{},dispatchFromFC);
      // await new Promise(resolve => setTimeout(resolve, 3000));
  
      const {auto_config:{
        enabled,price_priority,speed_priority
      },auto_create_return,speedpak_mode}=data||{}
    
      const config = {
        fourteenDayReturnsAccepted: auto_create_return,
        isSpeedPakAggressiveMode: speedpak_mode,
        shippingServiceConfigType: enabled ? 'ai' : 'manual',
        shippingServicePriority: speed_priority ? 'edd' : 'price',
      };
  
      dispatch({ type: SET_SHIPPING_AUTOCONFIG, payload: {config} });
     
    } catch (err) {
    }finally{
      dispatch({ type: SET_SHIPPING_SETTINGS_LOADING, payload: {shippingSettingsLoading:false} });
    }

  };







export const setShippingSettingsLoading = (loading)=>(dispatch) => {
  dispatch({
    type: SET_SHIPPING_SETTINGS_LOADING,
    payload: {shippingSettingsLoading:loading},
  })
};


export const TOGGLE_HTTP_ERROR_ALERT = prefix('TOGGLE_HTTP_ERROR_ALERT');
export const openHttpErrorAlert =(shippingHttpErrorMsg) =>  (dispatch) => {
  dispatch({
  type: TOGGLE_HTTP_ERROR_ALERT,
  payload: {shippingHttpErrorAlertOpenStatus:true,shippingHttpErrorMsg}
})};

export const closeHttpErrorAlert = () => (dispatch) => {
  dispatch({
  type: TOGGLE_HTTP_ERROR_ALERT,
  payload: {shippingHttpErrorAlertOpenStatus:false,shippingHttpErrorMsg:""}
})};


export const SUCCESS_TOAST = prefix('SUCCESS_TOAST');


// duration: milliseconds
export const openSuccessToast = (duration = 2000) => (dispatch) => {
  dispatch({
    type: SUCCESS_TOAST,
    payload: { shippingSuccessToastStatus: true }
  })

  let timer = setTimeout(() => {
    dispatch({
      type: SUCCESS_TOAST,
      payload: { shippingSuccessToastStatus: false }
    })
     clearTimeout(timer)
     timer = null
  }, duration);
 
};

export const closeSuccessToast = () => (dispatch) => {
  dispatch({
  type: SUCCESS_TOAST,
  payload: {shippingSuccessToastStatus:false}
})};


export const SHOULD_LOADING = prefix('SHOULD_LOADING');

export const startLoading =() =>  (dispatch) => {
  dispatch({
  type: SHOULD_LOADING,
  payload: {shouldLoading:true}
})};

export const stopLoading = () => (dispatch) => {
  dispatch({
  type: SHOULD_LOADING,
  payload: {shouldLoading:false}
})};


export const SET_NOTIFICATIONS = prefix('SET_NOTIFICATIONS');
export const sendNotifications =({notifications}) =>  (dispatch) => {
  dispatch({
  type: SET_NOTIFICATIONS,
  payload: {notifications}
})};